export const odluka_smjestaj = {
    templateId: 238,
    category: 4,
    templateTitle: "Odluka poslodavca o isplati naknade troškova smještaja radnika",
    templateDescription: `<p>Jedan od načina podmirenja troška smještaja radnika je mogućnost da radnik samostalno ugovori uslugu smještaja s pružateljem usluge, a da mu poslodavac isplaćuje naknadu troškova smještaja na temelju posebne odluke te preostale vjerodostojne dokumentacije.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>

    <p>Troškovi smještaja radnika nastali za vrijeme radnog odnosa kod poslodavaca mogu biti neoporezivo podmireni radniku do visine stvarnih izdataka, pri čemu se neoporezivi primitak priznaje za mjesec u kojemu je usluga smještaja obavljena.</p>
    <p>Trošak smještaja radnika može biti podmiren:</p>
    <li>na način da poslodavac  s trećima ugovori pružanje usluga smještaja za radnika, ili</li>
    <li>organizacijom smještaja radnika kod samog poslodavca, ili </li>
    <li><strong>na način da radnik sam sklopi ugovor o najmu s pružateljem usluge ili nađe smještaj,  pri čemu se radniku isplaćuje naknada troškova smještaja, a o čemu  poslodavac donosi odluku o isplati naknade.</strong></li>
    <br>
    <p>Zadnje spomenuti način reguliranja troškova smještaja razmatra se u nastavku ovog teksta te se potom daje primjer navedene odluke.</p>
    <p>Kod ove vrste naknade troška smještaja važno je naglasiti da je poslodavac dužan u svojoj poslovnoj dokumentaciji zadržati kopije vjerodostojne dokumentacije (kopija ugovora o najmu između radnika i pružatelja usluge ili kopija računa za najamninu).</p>
    <p>Ukoliko ugovor o najmu glasi na više osoba, neoporezivim primitkom smatrati će se samo onaj dio troška smještaja koji se može pripisati tom radniku.</p>
    <p>Trošak smještaja ne uključuje stavke koje se uobičajeno ne pripisuju tim troškovima (npr. korištenje garaže, posebno plaćeni izdaci za korištenje telefona i interneta, posebna naplata utroška struje, vode, grijanja i slično).</p>
    <p>Smatra da je primitak ostvaren u trenutku kad je radniku isplaćena naknada za podmirivanje troškova smještaja.</p>
    <p><strong>Ako se trošak smještaja isplaćuje radniku koji je istovremeno zaposlen kod dva ili više poslodavaca, radnik je dužan prije isplate dostaviti poslodavcu izjavu o tome jesu li mu navedeni primici već isplaćeni za isto razdoblje kod drugog/drugih poslodavaca. </strong></p>
    <p>U tom smislu i izrađen primjerak izjave koji možete vidjeti <a class="local-link" href="/contract?template=238.1">ovdje</a>.</p>
    </p>U slučaju da su drugi poslodavci isplatili dio troška smještaja, poslodavac može neoporezivo isplatiti preostali dio troška smještaja, ali samo do visine stvarnih izdataka.</p>
    <p><strong>U slučaju da radnik više nema izdataka za smještaj, obvezan je o istom obavijestiti poslodavca, a primjerak navedene obavijesti možete vidjeti <a class="local-link" href="/contract?template=238.2">ovdje</a>.</strong></p>

    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O ISPLATI NAKNADE TROŠKOVA SMJEŠTAJA RADNIKA',
    noArticleNumbers: true,

    articles: [

        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                              { type: "text", content: "Ovom Odlukom uređuje se pravo na naknadu troškova smještaja svih radnika zaposlenih kod Poslodavca (u daljnjem tekstu: Naknada)." },
                            ]
                            },
                        {
                            parts: [
                              { type: "text", content: "Ovom Odlukom uređuje se pravo radnika" },
                              { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                              { type: "text", content: "," },
                              { type: 'text', content: 'iz' },
                              { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                              { type: 'text', content: ',' },
                              { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                              { type: 'text', content: ',' },
                              { type: 'text', content: 'OIB:' },
                              { type: "input",  required: true,},
                              { type: "text", content: ", (u daljnjem tekstu: Radnik), na naknadu troškova smještaja (u daljnjem tekstu: Naknada)." },
                              ]
      }],
      value: '',
      }
      ]
      },
      {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Naknada iz ove Odluke isplaćuje se do visine stvarnih izdataka." },
                        ]
                        },
                    {
                        parts: [
                          { type: "text", content: "Naknada iz ove Odluke isplaćuje se u iznosu od" },
                          { type: 'input', value: '', required: true, placeholder: "Unesite iznos.", },
                          { type: "text", content: "kn,  ali ne više od stvarnih izdataka." },
               
                          ]
  }],
  value: '',
  }
  ]
  },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Naknada iz ove Odluke neće se isplatiti radniku koji u cijelosti ostvaruje pravo na naknadu troškova smještaja kod drugog/drugih poslodavca.\r\nU slučaju da radnik ostvaruje kod drugog/drugih poslodavca pravo na naknadu dijela troškova smještaja, ali ne do punog iznosa stvarnih izdataka, Poslodavac će radniku isplatiti preostali dio troška smještaja u skladu s ovom Odlukom, ali samo do visine stvarnih izdataka.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Preduvjet za ostvarenje Naknade je da Radnik preda Poslodavcu kopiju računa ili kopiju ugovora o najmu koji je zaključio s pružateljem usluga smještaja, a koji moraju glasiti na radnika.\r\nUkoliko ugovor o najmu glasi na više osoba, neoporezivim primitkom tog radnika smatrati će se samo onaj dio troška smještaja koji se može pripisati radniku. Trošak smještaja ne uključuje stavke koje se uobičajeno ne pripisuju tim troškovima (npr. korištenje garaže, posebno plaćeni izdaci za korištenje telefona i interneta, posebna naplata utroška struje, vode, grijanja i slično).',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Naknada za troškove smještaja iz ove Odluke isplaćuje se na račun radnika, do 15-og u mjesecu, za prethodni mjesec, a na temelju vjerodostojne dokumentacije (kopija ugovora o najmu ili kopija računa).',
                        'Naknada za troškove smještaja iz ove Odluke isplaćuje se na račun radnika, do 15-og u mjesecu, za tekući mjesec, a na temelju vjerodostojne dokumentacije (kopija ugovora o najmu ili kopija računa).'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Naknada iz ove Odluke isplaćuje se na redovan račun radnika.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba \r\n3) Obračun plaća',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};
        


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/238_odluka_smjestaj.ts